import { Component, OnInit, ViewChild, ElementRef, OnChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MenuItem } from 'primeng/primeng';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
    selector: 'scv-menu',
    templateUrl: 'scv.menu.html',
    styleUrls: ['scv.menu.css']
})
export class ScvMenuComponent implements OnInit {
    @Output() activemenu: EventEmitter<any> = new EventEmitter()
    ActiveMenu: number = 0;
    hideSubMenu = false;
    user: any;
    menuItems: MenuItem[];
    constructor(private route: ActivatedRoute, private router: Router, private translate: TranslateService, private cdRef: ChangeDetectorRef) {
        translate.use(localStorage.getItem('defaultLang'))
    }
    ngAfterViewInit() {
        this.cdRef.detectChanges();
    }

    ngOnInit() {
        this.translate.use(localStorage.getItem('defaultLang'))
        this.menuItems = [
            {
                label: 'SCV.LABEL.HOME', icon: 'fa fa-fw fa-book', badge: '8', ['routerLink']: '/Home', title: 'Home'
            },
            {
                label: 'SCV.LABEL.INTERNATIONALIZATION', ['routerLink']: '/i18n/content/label-list', icon: 'fa fa-fw fa-tachometer', badge: '8', title: 'content',
                items: [
                    { label: 'SCV.LABEL.LABELS', icon: 'fa fa-fw fa-pied-piper', ['routerLink']: '/i18n/content/label-list', title: 'content' },
                    { label: 'SCV.LABEL.CONSENTFORM', icon: 'fa fa-fw fa-bars', ['routerLink']: '/i18n/content/consent-list', title: 'content' },
                ]
            },
            {
                label: 'SCV.LABEL.CONFIGURE', icon: 'fa fa-fw fa-book', badge: '8', ['routerLink']: '/i18n/configure', title: 'configure'
            },
        ];
         
    }

        
    SelcetedMenu(event, index) {
        this.hideSubMenu = false
        const activeURL = this.route.snapshot['_routerState'].url
        if (activeURL && activeURL.match(event.title)) {
            this.ActiveMenu = index
            this.hideSubMenu = true
            return true
        }else if(activeURL == '/'){
            this.ActiveMenu = 0
            this.hideSubMenu = true
        }else {
            this.hideSubMenu = false
            return false
        }
    }

    active(i) {
        this.activemenu.emit()
        this.ActiveMenu = i
        this.hideSubMenu = false
    }

    isActive(e) {
        this.hideSubMenu = !this.hideSubMenu
        if (this.route.snapshot['_routerState'].url === e.routerLink) {
            return true
        } else {
            return false
        }
    }

}
